import { useCallback, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectPosthogEarlyAccessFeatures } from 'ducks/currentUser/selectors'
import { doUpdatePosthogEarlyAccessEnrollment } from 'ducks/currentUser/operations'
import { getTrackingContext } from 'ducks/tracking/context'

import Button from '@groovehq/internal-design-system/lib/components/Button/Button'

import { styles } from '../styles'

const SIGNED_KEY = 'ai-early-access-requested'

const BetaSignUp = () => {
  const { initialized: posthogInitialized } = getTrackingContext()
  const isSigned = useSelector(selectPosthogEarlyAccessFeatures)[SIGNED_KEY]

  const dispatch = useDispatch()

  const onClick = useCallback(
    () => {
      dispatch(doUpdatePosthogEarlyAccessEnrollment(SIGNED_KEY, true))
    },
    [dispatch]
  )

  if (!posthogInitialized) {
    return null
  }

  return (
    <div className="grui flex flex-col mt-12">
      <span css={styles.actionTitle}>
        Want to try out more of our new AI features?
        <br />
        Sign up for our early access.
      </span>

      {isSigned ? (
        <span className="grui mt-4">
          Your spot in line is saved. We&#39;ll let you know as soon as you have
          access!
        </span>
      ) : (
        <Button
          className="grui mt-5 mr-auto px-6"
          type="tertiary"
          size="small"
          onClick={onClick}
          css={styles.actionButton}
        >
          Add me to the list
        </Button>
      )}
    </div>
  )
}

export default memo(BetaSignUp)
